import { render, staticRenderFns } from "./500.vue?vue&type=template&id=55643c78&scoped=true"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&id=55643c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55643c78",
  null
  
)

export default component.exports